import { createAsyncThunk } from "@reduxjs/toolkit";
import { globalAPIDictionary } from "../../core/global/global-country-dictionary";
import axios from "axios";
import { captureException } from "@sentry/browser";
import { getIntelUrl } from "@utils/intelUrl";
import { toast } from "react-toastify";
import LocalStorageService from "@core/services/local-storage.service";
import { handleDownloadError, isJsonResponse } from "@utils/utils";
import moment from "moment";
import { getSaveSearchUrl } from "@containers/CompanyBookmark/utils/helper";
import { profileName, profileType } from "../../utils/enum";
const localStorageService = LocalStorageService.getService();

const { addFavouriteCompany, usersAllFavouriteCompanyTags, updateEmailAlertStatus, sendcompanyProfileToZoho, sendcompanyProfileToHubspot, sendcompanyProfileToSalesforce, createExcelFavouriteCompany, getFavouriteDetails, getProfileSlugID } = globalAPIDictionary;

export const updateFavouriteTagsHandler = createAsyncThunk("data/updateFavtags", async (payload, thunkAPI) => {
  try {
    const { updateFav, payload: favPayload } = payload;
    await axios.post(addFavouriteCompany, updateFav);
    const favData = await thunkAPI.dispatch(getFavouriteDetailsHandler({ payload: favPayload }));
    toast.success("Tags updated successfully");
    return favData;
  } catch (error) {
    captureException(error);
  }
});

export const getFavouriteTagsHandler = createAsyncThunk("data/getFavtags", async (profileType) => {
  try {
    const { data } = await axios.get(usersAllFavouriteCompanyTags + "?type=" + profileType);
    return data;
  } catch (error) {
    captureException(error);
  }
});

export const setEmailAlertHandler = createAsyncThunk("data/setEmailAlert", async (payload) => {
  try {
    const data = await axios.post(updateEmailAlertStatus, payload);
    return !!data || true;
  } catch (error) {
    captureException(error);
    return false;
  }
});

export const getCompanyProfileSlug = createAsyncThunk("data/getCompanyProfileSlug", async (payload) => {
  try {
    const { data } = await axios.post(getProfileSlugID, {
      profile_type: payload.type,
      _id: payload._id,
    });
    return data;
  } catch (error) {
    captureException(error);
  }
});

export const getSlugAndSetEmailHandler = createAsyncThunk("data/fetchUserAndPosts", async (row, thunkAPI) => {
  const { data, payload: favPayload } = row;
  const userSlug = await thunkAPI.dispatch(getCompanyProfileSlug({ _id: data.company_id, type: favPayload.type }));
  let url = getIntelUrl() + userSlug.payload.data.companySlug + "/" + userSlug.payload.data.aliasCompanyId;
  url = getSaveSearchUrl(data, url);
  let payload = {
    company_id: data.company_id,
    company_name: data.company_name,
    frequency: 30,
    is_email_alert: data.checked,
    source: profileType.company,
    url: url,
  };
  await thunkAPI.dispatch(setEmailAlertHandler(payload));
  await thunkAPI.dispatch(getFavouriteDetailsHandler({ payload: favPayload }));
});

export const addToZohoHandler = createAsyncThunk("data/addToZoho", async (payload) => {
  try {
    const { selectedCompanyArray } = payload;
    const requestObject = [];
    selectedCompanyArray
      .filter((item) => item.is_merged === false)
      .map((item) => {
        if (!!item && !!item.company_id) {
          requestObject.push(item.company_id);
        }
      });
    if (selectedCompanyArray.length && !requestObject.length) {
      toast.error("Please select companies other than Merged companies to add to Zoho");
      return;
    }
    axios.post(sendcompanyProfileToZoho, { company_id: requestObject }).then((res) => {
      if (!!res && !!res.data && !!res.data.data) {
        if (res.data.status && res.data.status.toLowerCase() === "success") {
          if (res.data.data.status && res.data.data.status.toLowerCase() === "complete".toLowerCase()) {
            if (selectedCompanyArray.length > requestObject.length) toast.success("Selected Companies, other than Merged Companies, have been successfully added to Zoho");
            else toast.success("Company sent successfully to Zoho");
          } else if (res.data.data.status && res.data.data.status.toLowerCase() === "duplicate".toLowerCase()) {
            toast.error(res.data.data.message);
          } else if (res.data && res.data.data && res.data.data.description && res.data.data.description.toLowerCase() === "Rest all Companies Created!".toLowerCase()) {
            toast.error(res.data.data.description);
          } else {
            toast.error("Something went wrong. Please try again after sometime!!!");
          }
        }
      } else {
        toast.error("Something went wrong. Please try again after sometime!!!");
      }
    });
  } catch (error) {
    captureException(error);
  }
});

export const addToHubspotHandler = createAsyncThunk("data/addToHubspot", async (payload) => {
  try {
    const { selectedCompanyArray } = payload;
    const requestObject = [];
    selectedCompanyArray
      .filter((item) => item.is_merged === false)
      .map((item) => {
        if (!!item && !!item.company_id) {
          requestObject.push(item.company_id);
        }
      });
    if (selectedCompanyArray.length && !requestObject.length) {
      toast.error("Please select companies other than Merged companies to add to HubSpot");
      return;
    }
    axios.post(sendcompanyProfileToHubspot, { company_id: requestObject }).then((res) => {
      if (!!res && !!res.data && !!res.data.data) {
        if (res.data.status.toLowerCase() === "success") {
          if (res.data.data.status.toLowerCase() === "complete".toLowerCase()) {
            if (selectedCompanyArray.length > requestObject.length) toast.success("Selected Companies, other than Merged Companies, have been successfully added to HubSpot");
            else toast.success("Company sent successfully to Hubspot");
          } else if (res.data.data.status.toLowerCase() === "duplicate".toLowerCase()) {
            toast.error(res.data.data.message);
          } else if (res.data && res.data.data && res.data.data.description && res.data.data.description.toLowerCase() === "Rest all Companies Created!".toLowerCase()) {
            toast.error("Something went wrong. Please try again after sometime!!!");
          }
        }
      } else {
        toast.error("Something went wrong. Please try again after sometime!!!");
        this.setState({
          isLoaderActive: false,
        });
      }
    });
  } catch (error) {
    captureException(error);
  }
});

export const addToSalesforceHandler = createAsyncThunk("data/addToSalesforce", async (payload) => {
  try {
    const { selectedCompanyArray } = payload;
    const requestObject = [];
    selectedCompanyArray
      .filter((item) => item.is_merged === false)
      .map((item) => {
        if (!!item && !!item.company_id) {
          requestObject.push(item.company_id);
        }
      });
    if (selectedCompanyArray.length && !requestObject.length) {
      toast.error("Please select companies other than Merged companies to add to Salesforce");
      return;
    }
    axios.post(sendcompanyProfileToSalesforce, { company_id: requestObject }).then((res) => {
      if (!!res && !!res.data && !!res.data.data) {
        if (res.data.status.toLowerCase() === "success") {
          if (res.data.data.description.toLowerCase() === "All Companies are Created".toLowerCase()) {
            toast.success(res.data.data.message);
          } else if (res.data.data.description.toLowerCase() === "All Companies are Duplicate!".toLowerCase()) {
            return res.data.data;
          } else if (res.data.data.description.toLowerCase() === "Rest all Companies Created!".toLowerCase()) {
            return res.data.data;
          }
        }
      } else {
        toast.error("Something went wrong. Please try again after sometime!!!");
      }
    });
  } catch (error) {
    captureException(error);
  }
});

export const downloadingCompanyExcel = createAsyncThunk("download/downloadingFavCompany", async (payload) => {
  try {
    const { selectedCompanyArray, fileInitName = `Favourite_${profileName[payload.type]}_`, type } = payload;
    let requestObj = {};
    requestObj.file_name = fileInitName + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime();
    requestObj.subscribed_plan = localStorageService && localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : "";
    requestObj.type = type;
    requestObj.data_download = selectedCompanyArray;
    const downloadShipmentApiUrl = createExcelFavouriteCompany;
    const request = new XMLHttpRequest();
    request.open("POST", downloadShipmentApiUrl, true);
    request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    request.responseType = "blob";
    request.setRequestHeader("sessionId", localStorageService.getSessionID());
    request.setRequestHeader("ssoToken", localStorageService.getAccessToken());
    request.onload = function () {
      if (request.status === 200 && !isJsonResponse(request)) {
        const contentTypeHeader = request.getResponseHeader("Content-Type");
        const file = new Blob([this.response], { type: contentTypeHeader });
        const url = window.URL.createObjectURL(file);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = requestObj.file_name + ".xlsx";
        a.click();
      } else {
        handleDownloadError(request);
      }
    };
    request.send(JSON.stringify(requestObj), this);
  } catch (error) {
    captureException(error);
  }
});

let cancelTokenSource;
export const getFavouriteDetailsHandler = createAsyncThunk("data/getFavouriteDetailsHandler", async (payload) => {
  try {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Request cancelled");
    }

    cancelTokenSource = axios.CancelToken.source();

    const { data } = await axios.post(
      getFavouriteDetails,
      {
        ...payload.payload,
      },
      {
        cancelToken: cancelTokenSource.token,
      }
    );
    return { data: data?.data, type: payload?.type };
  } catch (error) {
    if (!axios.isCancel(error)) {
      captureException(error);
    }
  }
});
